<template>
  <yiban-tool :flow="flow"> </yiban-tool>
</template>
<script>
import yibanTool from "./yibanTool.vue";
export default {
  components: { yibanTool },
  data() {
    return {
      flow: {
          id: "1627969124636323842",
          name: "应急管理",
          name1: "应急待办处理",
        },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/yibanchuli2.vue